import { UtmDataService } from '@/app/shared/services/utm-data.service';
// src/app/services/utm-tracker.service.ts

import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '@/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UtmTrackerService {
  private readonly utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private utmDataService: UtmDataService,
  ) {}

  /**
   * Reads UTM params from URL, saves them to localStorage
   */
  captureUtmParams(): void {
    this.route.queryParams.subscribe((params) => {
      const utmData: any = {};
      let hasUtm = false;

      this.utmKeys.forEach((key) => {
        if (params[key]) {
          const camelKey = this.toCamelCase(key);
          utmData[camelKey] = params[key];
          hasUtm = true;
        }
      });

      if (hasUtm) {
        utmData.userAgent = navigator.userAgent;
        utmData.ipAddress = null; // Backend can detect IP
        this.utmDataService.sendUtmToBackend(utmData);
      }
    });
  }

  private toCamelCase(snake: string): string {
    return snake.replace(/_([a-z])/g, (_, g1) => g1.toUpperCase());
  }
}
